import React, { useContext } from "react";
import { SystemContext } from "../context/SystemContext";

const ShippingCheckoutBanner = ({ totalAmount }) => {
  const { shipmentSettings } = useContext(SystemContext);
  const freeShipmentThreshold = shipmentSettings?.freeShipmentThreshold || 100;

  if (!shipmentSettings) {
    return null; // Or a loading indicator
  }

  if (totalAmount >= freeShipmentThreshold) {
    return;
  } else {
    const amountLeft = freeShipmentThreshold - totalAmount;
    return (
      <div style={{ background: "#3B72FE", color: "#fff", padding: "8px 0px", fontSize: ".8rem", fontWeight: "600", textAlign: "center" }}>{`Only $${Math.ceil(
        amountLeft
      ).toFixed(0)} more for FREE shipping`}</div>
    );
  }
};

export default ShippingCheckoutBanner;
